import React from 'react';
import { QuoteIcon } from 'lucide-react';
export function DatabaseUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-2452">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2453">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2454">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2455">
            The local business database for{' '}
            <span className="text-blue-600" data-id="element-2456">every team</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-2457">
            From sales to marketing, see how teams use our local business owner
            finder to grow their revenue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2458">
          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2459">
            <div data-id="element-2460">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2461">
                B2B Sales Outreach
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2462">
                Sales teams use our built-in email sequencing to reach local
                small businesses directly, bypassing gatekeepers with verified
                business owner emails.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2463">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2464" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2465">
                Having the database and sequencing in one tool doubled our SDRs'
                daily output.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2466">
                — Mark R., VP of Sales
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2467">
            <div data-id="element-2468">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2469">
                Local Marketing
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2470">
                Agencies build hyper-targeted local business listings to run
                personalized campaigns for their clients across specific regions
                and industries.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2471">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2472" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2473">
                The local business database coverage is unmatched. We find
                niches ZoomInfo completely misses.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2474">
                — Elena S., Agency Owner
              </p>
            </div>
          </div>

          <div className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-2475">
            <div data-id="element-2476">
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-2477">
                Franchise Expansion
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-2478">
                Franchisors use the local business owner finder to identify
                successful independent operators and pitch them on conversion
                opportunities.
              </p>
            </div>
            <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-2479">
              <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-2480" />
              <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-2481">
                We can view business owner emails before exporting, ensuring we
                only contact the actual decision makers.
              </p>
              <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-2482">
                — David L., Head of Growth
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}